export function formatDate(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${y}.${m}.${d}`;
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}

export function formatDateRange(startDate, endDate, isOngoing) {
  const start = formatDate(startDate);
  if (isOngoing || !endDate) return `${start} ~ 현재`;
  return `${start} ~ ${formatDate(endDate)}`;
}
